import customizeScrollbar from "customsb";
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { vhostV1 } from "../funcoes";
import Navbar from "../navbar/navbar";
import FooterBar from "../footer/footerBar";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link, Navigate } from "react-router-dom";
import './fichaTecnica.css'; 
import SRI_pagination from "../components/pagination/pagination";
import BuscaVazaia from "../components/buscavazia/buscaVazia";
import RelatorioFichaTecnica from "../reports/fichaTecnica/listaFichaRelatorio";
import {
  Container,
  Grid,
  Paper,
  Typography,
  Divider,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Menu,
  Stack,
} from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PrintIcon from "@mui/icons-material/Print";



function FichaTecnica(){
     const [nPag, setnPag] = useState(1);
     const [totalPaginas, setTotalPaginas] = useState(0);
     const [texto,setTexto] = useState('');
     const [busca,setBusca] = useState("");
     const [sResult,setSresult] = useState(0);
     const [tpBusca,setTpBusca] = useState(0);
     const [erroValidacao, setErrovalidacao] = useState(false);
     const [navegar, setNavegar] = useState(false);
     const [msgErro, setmsgErro] = useState('');
     const [fichas, setFichas] = useState([]);
     const [confirmacaoExclusao,setConfirmacaoExclusao] = useState(false);
     const [confirmacaoId,setConfirmacaoID] = useState('');

     let config = {
        headers: {
          'Authorization': localStorage.getItem("token")
        }
      }

    function handlePageChange(value){
        if(value === "&laquo;" || value === '... '){
          setnPag(1);
        }else if (value === "&lsaquo;" ){
          if (nPag !== 1){
            setnPag(-1);
          }
        }else if(value === "&rsaquo;"){
          setnPag(+1);        
        }else if(value === "&raquo;" || value === ' ...' ){
          setnPag(totalPaginas);        
        }else{
          setnPag(value);
        }    
       
       }

       useEffect(function(){
        const sJson = {}  
        sJson.busca = busca;
        sJson.pagina = nPag;
        sJson.regPag = 10;
        
        api.post(vhostV1('webcash/produto/fichas'),sJson,config)
        .then(function (response) {
          setSresult(response.data.result);
          setFichas(response.data.dados);
          setTotalPaginas(response.data.quantidadeDePaginas);
          console.log(response);
          
        }
       ).catch(function (error) {
        console.log(error);
        
       });
       },[busca])


       function apagaFicha(cod){
        
        api.post(vhostV1('webcash/produto/ficha/deletar/'+Number(cod)),{},config)
        .then(function (response) {
          
          console.log(response);
          setConfirmacaoExclusao(false)
          setNavegar(true);
        }
       ).catch(function (error) {
        console.log(error);
        setConfirmacaoExclusao(false)
        
       });
       }

       function confirmadeleteUser(cod){
        setConfirmacaoID(cod);
        setConfirmacaoExclusao(true);
        
     }
  
     
  useEffect(() => {
    // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
    customizeScrollbar({
      scrollbarWidth: "10px",
      trackBackground: "#333",
      thumbBackground:
        "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
      thumbBorderRadius: "10px",
    });
  }, []);



      return (
  <div>
    <Navbar />

    <Container maxWidth="xl" sx={{ mt: 5, mb: 4 }}>
      <Typography
  variant="h4"
  fontWeight={600}
  gutterBottom
  sx={{ mt: 10 }}
>
  Ficha Técnica de Produtos
</Typography>

      <Divider sx={{ mb: 4 }} />
<Grid
  container
  spacing={2}
  alignItems="center"
  sx={{ mb: 3 }}
>

  {/* Tipo de Busca */}
  <Grid size={{ xs: 12, md: 2 }}>
    <FormControl fullWidth size="small">
      <Select
        value={tpBusca}
        onChange={(e) => setTpBusca(e.target.value)}
      >
        <MenuItem value={0}>Qualquer parte</MenuItem>
        <MenuItem value={1}>Começando com...</MenuItem>
        <MenuItem value={2}>Finalizando com...</MenuItem>
      </Select>
    </FormControl>
  </Grid>

  {/* Pesquisa */}
  <Grid size={{ xs: 12, md: 7 }}>
    <Stack direction="row" spacing={1}>
      <TextField
        fullWidth
        size="small"
        placeholder="Digite sua pesquisa"
        onChange={(e) => setTexto(e.target.value)}
      />

      <Button
        variant="contained"
        startIcon={<SearchIcon />}
        onClick={() => setBusca(texto)}
      >
        Pesquisar
      </Button>
    </Stack>
  </Grid>

  {/* Botões à direita */}
  <Grid
    size={{ xs: 12, md: 3 }}
    sx={{
      display: "flex",
      justifyContent: {
        xs: "flex-start",
        md: "flex-end"
      }
    }}
  >
    <Stack direction="row" spacing={1}>

      <Button
        component={Link}
        to="/app/novaFichaTecnica/0/-1"
        variant="contained"
        startIcon={<AddCircleIcon />}
      >
        Ficha Técnica
      </Button>

      <Button
        variant="contained"
        color="error"
        startIcon={<PrintIcon />}
        onClick={() => RelatorioFichaTecnica(fichas)}
      >
        Relatório
      </Button>

    </Stack>
  </Grid>

</Grid>

      <Paper elevation={3} sx={{ mt: 4 }}>
        <TableContainer>
          <Table>

            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Código</strong>
                </TableCell>

                <TableCell>
                  <strong>Descrição</strong>
                </TableCell>

                <TableCell width={120}>
                  <strong>Ações</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {fichas
                ? fichas.map((produto) => (
                    <TableRow
                      key={produto.COD_PRODUTO}
                      hover
                    >
                      <TableCell>
                        {produto.COD_PRODUTO}
                      </TableCell>

                      <TableCell>
                        {produto.DESCRICAO}
                      </TableCell>

                      <TableCell>
                        <Button
                          variant="outlined"
                          size="small"
                          data-bs-toggle="dropdown"
                        >
                          Ações
                        </Button>

                        <ul className="dropdown-menu">

                          <li>
                            <Link
                              to={`/app/novaFichaTecnica/${produto.COD_PRODUTO}/0`}
                              className="dropdown-item"
                            >
                              <i className="bi bi-eye-fill"></i>
                              {" "}Visualizar
                            </Link>
                          </li>

                          <li>
                            <Link
                              to={`/app/novaFichaTecnica/${produto.COD_PRODUTO}/2`}
                              className="dropdown-item"
                            >
                              <i className="bi bi-pen-fill"></i>
                              {" "}Editar
                            </Link>
                          </li>

                          <li>
                            <button
                              onClick={() =>
                                confirmadeleteUser(
                                  produto.COD_PRODUTO
                                )
                              }
                              className="dropdown-item"
                            >
                              <i className="bi bi-trash-fill"></i>
                              {" "}Excluir
                            </button>
                          </li>

                        </ul>
                      </TableCell>
                    </TableRow>
                  ))
                : BuscaVazaia}
            </TableBody>

          </Table>
        </TableContainer>
      </Paper>

      <Paper
        elevation={1}
        sx={{
          mt: 4,
          p: 2,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <SRI_pagination
          totalPage={totalPaginas}
          page={nPag}
          limit={10}
          siblings={1}
          onPageChange={handlePageChange}
        />
      </Paper>

      {erroValidacao ? (
        <SweetAlert
          danger
          confirmBtnText="OK"
          confirmBtnBsStyle="danger"
          title="Erro"
          onConfirm={() => setErrovalidacao(false)}
        >
          {msgErro}
        </SweetAlert>
      ) : null}

      {confirmacaoExclusao ? (
        <SweetAlert
          warning
          showCancel
          showCloseButton
          confirmBtnText="Sim"
          confirmBtnBsStyle="danger"
          cancelBtnText="Não"
          cancelBtnBsStyle="ligth"
          title="Atenção"
          onConfirm={() => apagaFicha(confirmacaoId)}
          onCancel={() => setConfirmacaoExclusao(false)}
          focusCancelBtn
          reverseButtons
        >
          Deseja excluir esta Ficha?
        </SweetAlert>
      ) : null}
{navegar ? (
        <Navigate to="/app/fichaTecnica" />
      ) && window.location.reload(): null}
      
    </Container>

    <FooterBar />
  </div>
);
  
};

export default FichaTecnica;